import { Component } from "@angular/core";

@Component({
    template: require('./story.component.html')
})
export class StoryComponent {

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader?keepUrl=true!./app/story.component.ts